import { z } from 'zod'
import { userSchema } from './user'
import {
    paginationLinksSchema,
    paginationMetaSchema,
} from '@/lib/schema/v1/pagination'

export const logAggregateSchema = z.object({
    uuid: z.string(),
    title: z.string(),
})

export const logMetaSchema = z.object({
    'aggregate-root-uuid': z.string().uuid(),
    'aggregate-root-version': z.number(),
    'created-at': z.coerce.date(),
    ip: z.string().ip(),
    'stored-event-id': z.number(),
    url: z.string().url(),
    user_agent: z.string(),
})

export const logSchema = z.object({
    aggregate: logAggregateSchema.nullable(),
    aggregate_type: z.string(),
    aggregate_uuid: z.string(),
    aggregate_version: z.number(),
    created_at: z.coerce.date(),
    creator: userSchema.nullish(),
    creator_type: z.string(),
    creator_uuid: z.string().uuid(),
    group_type: z.string().nullable(),
    group_uuid: z.string().uuid().nullable(),
    id: z.number(),
    meta_data: logMetaSchema,
    properties: z.any(),
    title: z.string(),
    type: z.string(),
    version: z.number(),
})

export const logsSchema = z.array(logSchema)

export const paginatedLogsSchema = z.object({
    data: logsSchema,
    links: paginationLinksSchema,
    meta: paginationMetaSchema,
})
